import axios from 'axios';

import { EVISIT_STATUS } from '../../config/constants';

export const loadAdtNotificationCount = (providerId) => (
	axios.get(`/providers/${providerId}/unread-adt-count-v2`)
);

export const loadCareQuestDashboardCount = (providerPracticeId) => (
	axios.get(`/provider_practices/${providerPracticeId}/care-quest-dashboard`)
);

export const loadVitalTrackerPatientCount = (providerId) => (
	axios.get(`/providers/${providerId}/vital-tracker-groups`)
);

export const generatePatientCode = async (providerId, { firstName, lastName, birthDate, providerCode }) => {
	const { data } = await axios.post(`/providers/${providerId}/generate-patient-pre-registration`, {
		name_first: firstName,
		name_last: lastName,
		birth_dt: birthDate,
		providerCode
	});
	return data.status;
};

export const loadProviderCodes = (providerId) => (
	axios.get(`/providers/${providerId}/get-pactice-provider-codes`)
);

export const submitSupportTicket = (providerId, ticketData) => (
	axios.post(`/providers/${providerId}/support-ticket`, ticketData)
);

export const loadOpenVisitIds = (providerPracticeId) => {
	let evisit_status = { nin: [EVISIT_STATUS.CANCELLED_APPOINTMENT] };
	const where = {
		and: [
			{ end_dttm: null },
			{ providerPracticeId: providerPracticeId },
			{ evisit_status },
			{ patientId: { neq: null } },
			{ or: [
				{ and: [{ start_dttm: { neq: null } }, { evisit_status: { nin: [EVISIT_STATUS.CANCELLED_APPOINTMENT] } }] },
				{ and: [{ start_dttm: { eq: null } }, { evisit_status: { inq: [EVISIT_STATUS.SCHEDULED_PENDING, EVISIT_STATUS.SCHEDULED] } }] }
			]}
		]
	};

	return axios.get(`/provider_practices/${providerPracticeId}/evisits`, { params: { filter: JSON.stringify({ where, fields: { id: true, evisit_status: true } }) } });
};

export const getUnsignedAgreements = (providerId) => (
	axios.get(`/providers/${providerId}/agreements_unsigned`)
);

export const signAgreement = (providerId, agreement_id) => (
	axios.post(`/providers/${providerId}/agreements_sign`, { agreement_id })
);
